<div style="display: flex; flex-direction: column; gap: 7px;">
    <div class="spec-edit-row" *ngFor="let row of rows; let i = index; trackBy: trackByIndex">
        <input
            class="input input-sm"
            [placeholder]="labelPlaceholder"
            [ngModel]="row.label"
            (ngModelChange)="updateLabel(i, $event)"
        />
        <input
            class="input input-sm"
            [placeholder]="valuePlaceholder"
            [ngModel]="row.value"
            (ngModelChange)="updateValue(i, $event)"
        />
        <button type="button" class="ic-act danger" (click)="removeRow(i)" aria-label="Remove spec">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
    </div>
</div>
<button type="button" class="seq-add-btn mt-2" (click)="addRow()">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>
    Add spec
</button>
